angular.module('app').factory('cacheService',['$window', function($window) {

    return {
        set: function (key, value, expireTimeInSeconds) {
          var data = {
              data: value,
              timestamp: new Date().getTime(),
              expireTimeInMilliseconds: expireTimeInSeconds * 1000
          };
            return $window.localStorage.setItem(key, JSON.stringify(data))
        },
        get: function (key) {
            var item = JSON.parse($window.localStorage.getItem(key));
            if (!item || new Date().getTime() > (item.timestamp + item.expireTimeInMilliseconds)) {
                return null
            } else {
                return item.data
            }
        }
    }
}]);
